import React from "react";

// Components
import { faCrop, faTrashCan } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonImg } from "@ionic/react";
import { withTranslation } from "react-i18next";
import { debug } from "../../App";
import IconButton from "../Button/Icon/IconButton";
import Cropper from "../Cropper/Cropper";
import { ModalConfirmation } from "../Modals";

class Image extends React.Component<any, any> {
  inputRef: React.RefObject<HTMLInputElement>;
  constructor(props: any) {
    super(props);

    this.inputRef = React.createRef();
    this.state = {
      showUi: false,
      fileName: "",
      modalOpen: false,
      fileUrl: this.props.value,
      uploadedFileUrl: null,
      cropperOpen: false,
    };
  }

  render() {
    const { t, cropper } = this.props;

    return (
      <>
        <label className="button__image-label" htmlFor={this.props.name}>
          <FontAwesomeIcon icon={["far", "camera"]} />
          {!this.state.fileUrl && <span className="button__image-label__title">{t("uploadImage")}</span>}
          <>
            {this.props.minimumSize && (
              <span>
                {t("minimumSize")}: {this.props.minimumSize}
              </span>
            )}
            {this.state.fileUrl && (
              <div className="button__image-label__preview">
                <img src={this.state.fileUrl} alt={t("preview")} />
                <IconButton icon={faCrop} align="left" className="button__image-label__crop" type="wire-circle" onClick={this.openCropper.bind(this)} tooltip="Crop" />
                <IconButton icon={faTrashCan} align="left" className="button__image-label__delete" type="wire-circle" color="danger" onClick={this.removeFile.bind(this)} tooltip="Discard" />
              </div>
            )}
          </>

          <input
            type="file"
            id={this.props.name}
            name={this.props.name}
            ref={this.inputRef}
            className={this.props.className}
            accept={"image/*"}
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                this.setState({
                  cropperOpen: true,
                  uploadedFileUrl: URL.createObjectURL(e.target.files[0]),
                });
              } else {
                this.setState({
                  uploadedFileUrl: null,
                });
              }
            }}
          />
        </label>
        {this.props.confirmModal && (
          <ModalConfirmation
            isOpen={this.state.modalOpen}
            classModifiers={`modal--secondary modal--profile-pictures-confirm ${this.props.profileImageCssModifier}`}
            heading={<span>Review Image</span>}
            closeModal={this.modalCancel}
            text={
              <div>
                <p>{t("imageInputExplainationText")}</p>
                <IonImg src={this.state.fileUrl} className={`image ${this.props.profileImageImgCssModifier}`} />
              </div>
            }
            buttons={[
              {
                text: t("cancel"),
                onClick: this.modalCancel,
                className: window.innerWidth < 992 ? "button--wire-white" : "button--wire-black",
              },
              {
                text: t("confirm"),
                onClick: this.modalConfirm,
              },
            ]}
          />
        )}
        <Cropper isOpen={this.state.cropperOpen} image={this.state.uploadedFileUrl} setImage={this.setImage.bind(this)} closeCropper={this.closeCropper.bind(this)} circle={false} options={cropper} />
      </>
    );
  }

  setImage = (file: File | null) => {
    if (file) {
      debug("Image.tsx", "setImage", file);

      const showUi = true;
      // @ts-ignore
      const fileUrl = URL.createObjectURL(file);

      // @ts-ignore
      this.setState({
        modalOpen: true,
        showUi,
        fileName: showUi ? file.name : "",
        fileUrl: fileUrl,
      });

      const ionEvent = new CustomEvent("ionChange", {
        detail: {
          name: this.props.name,
          value: file,
        },
      });
      if (this.props.onChange) {
        this.props.onChange(ionEvent);
      } else {
        this.props?.onIonChange(ionEvent);
      }
    }
  };

  openCropper = (event: Event) => {
    event?.preventDefault();
    this.setState({ cropperOpen: true });
  };

  closeCropper = () => {
    this.setState({ cropperOpen: false });
  };

  modalCancel = () => {
    this.setState({ modalOpen: false });
    this.removeFile();
  };

  modalConfirm = () => {
    this.setState({
      modalOpen: false,
    });
  };

  removeFile(event?: Event) {
    event?.preventDefault();

    // Create an empty file object with a placeholder name
    const emptyFile = new File([], "empty.jpg", { type: "image/*" });

    this.setState({ fileUrl: "" });

    // @ts-ignore
    this.inputRef.current.value = null;

    // Trigger change event with the empty file object
    const ionEvent = new CustomEvent("ionChange", {
      detail: {
        name: this.props.name,
        value: emptyFile,
      },
    });

    this.props.onIonChange(ionEvent);
  }
}

export default withTranslation()(Image);
